// import React from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Autoplay, Pagination } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/pagination";
// import "./carousel.css";

// import davidSmith from "../../images/david.webp";
// import paulWagner from "../../images/paul.webp";
// import markLFox from "../../images/mark.webp";
// import randyBoldyga from "../../images/randy-boldyga.svg";
// import guySimani from "../../images/guy-simani.svg";
// import chuckEast from "../../images/chuck-east.svg";
// import JimTormey from "../../images/jim-tormey.webp";

// import { Container } from "react-bootstrap";

// const testimonials = [
//     {
//         imgSrc: davidSmith,
//         name: "David Smith, CEO Tynax, Inc",
//         text: "I have been very impressed by ACube's work and would highly recommend them. They quickly perform the work, solve all technical issues in the process, deliver finished results and then check back to ensure that all is working OK. They are a pleasure to work with and I plan to use ACube for several projects in the future.",
//     },
//     {
//         imgSrc: paulWagner,
//         name: "Paul Wagner, CEO CreativeLab",
//         text: "ACube Technologies is a sharp, dedicated group of guys who will do whatever it takes to complete a job and fulfill a commitment. They ask the right questions, communicate throughout the process and they deliver high-quality work on time and on budget. I recommend ACube for your next project. Hire them, they're great to work with.",
//     },
//     {
//         imgSrc: markLFox,
//         name: "Mark L Fox, Vice President SAAF",
//         text: "I have been working with Acube Technologies for 2 years now. My plan was for them to help me with a few tasks, but today they simply are my entire IT staff. They are technically capable and are extremely fair as far as costs. I work with them 7 days a week and my business would not exist without them....they have helped me grow my business 300%.",
//     },
//     {
//         imgSrc: randyBoldyga,
//         name: "Randy Boldyga, CEO/President RxNT",
//         text: "Acube provided excellent service and demonstrated strong technical capability. I would recommend.",
//     },
//     {
//         imgSrc: guySimani,
//         name: "Guy Simani, President, Emerald Capital Management",
//         text: "The ACube team are reliable, responsive and diligent.",
//     },
//     {
//         imgSrc: chuckEast,
//         name: "Chuck East, Technical Product Manager, Openn North America",
//         text: "I wanted to email you my sentiments expressed at the end of our side so you can share my appreciation with your teams. Thank you for everyone’s willingness to pull together around the shifting priorities coming into engineering. The hard work, extra hours, and deep product knowledge are examples of how the teams go the extra mile. I have been managing offshore teams for many years, and the Openn engineering team is by far the brightest and most dedicated. Thank you for your continued efforts.",
//     },
//     {
//         imgSrc: JimTormey,
//         name: "Jim Tormey, Chief Executive Officer, Sentry Road Training and Development",
//         text: "My name is Jim, and I run a learning management software business on Moodle. A few months ago, we needed a part-time developer for projects like platform upgrades and automated reports. The Acube Technologies team has been phenomenal—responsive, communicative, and reliable. They followed through on every commitment and kept me informed of any challenges. I’m a big fan and look forward to working with them in the future.",
//     },
// ];

// const TestimonialCarousel = () => {
//     return (
//         <section className="testimonial-section px-0">
//             <Container fluid>
//                 <h1 className="title-text text-uppercase text-center text-white mb-3 mb-lg-5">
//                     What people say about us
//                 </h1>

//                 <Swiper
//                     modules={[Autoplay, Pagination]}
//                     autoplay={{ delay: 3000, disableOnInteraction: false }}
//                     pagination={{ clickable: true }}
//                     loop={true}
//                     speed={600}
//                     spaceBetween={30}
//                     slidesPerView={1} // 👈 default = 1 for mobile
//                     breakpoints={{
//                         640: { slidesPerView: 2 },  // tablets
//                         1200: { slidesPerView: 3 }, // desktops
//                     }}
//                     className="testimonial-carousel"
//                 >
//                     {testimonials.map((testimonial, index) => (
//                         <SwiperSlide key={index}>
//                             <div className="pt-50">
//                                 <div className="testimonial-img-div">
//                                     <img
//                                         className="mb-3 testimonial-img"
//                                         loading="lazy"
//                                         src={testimonial.imgSrc}
//                                         alt={testimonial.name}
//                                         height="100"
//                                     />
//                                 </div>
//                                 <div className="bg-light p-4 pb-5 mx-3 rounded-4 card-height h-100">
//                                     <div className="content-block">
//                                         <h4 className="mb-2 mb-lg-3 fw-bold text-primary">
//                                             {testimonial.name}
//                                         </h4>
//                                         <h6 className="mb-4 text-primary">{testimonial.text}</h6>
//                                     </div>
//                                 </div>
//                             </div>
//                         </SwiperSlide>
//                     ))}
//                 </Swiper>
//             </Container>
//         </section>
//     );
// };

// export default TestimonialCarousel;


import React, { useRef } from "react";
import { Container } from "react-bootstrap";
import davidSmith from "../../images/david.webp";
import paulWagner from "../../images/paul.webp";
import markLFox from "../../images/mark.webp";
import randyBoldyga from "../../images/randy-boldyga.svg";
import guySimani from "../../images/guy-simani.svg";
import chuckEast from "../../images/chuck-east.svg";
import JimTormey from "../../images/jim-tormey.webp";

// Web-safe placeholders to ensure the code compiles in the sandbox environment.
// When pasting into your local project, replace these strings with your local imports:
// import davidSmith from "../../images/david.webp"; etc.


const testimonials = [
    {
        imgSrc: davidSmith,
        name: "David Smith",
        role: "CEO",
        company: "Tynax, Inc",
        text: "I have been very impressed by ACube's work and would highly recommend them. They quickly perform the work, solve all technical issues in the process, deliver finished results and then check back to ensure that all is working OK. They are a pleasure to work with and I plan to use ACube for several projects in the future.",
    },
    {
        imgSrc: paulWagner,
        name: "Paul Wagner",
        role: "CEO",
        company: "CreativeLab",
        text: "ACube Technologies is a sharp, dedicated group of guys who will do whatever it takes to complete a job and fulfill a commitment. They ask the right questions, communicate throughout the process and they deliver high-quality work on time and on budget. I recommend ACube for your next project.",
    },
    {
        imgSrc: markLFox,
        name: "Mark L Fox",
        role: "Vice President",
        company: "SAAF",
        text: "I have been working with Acube Technologies for 2 years now. My plan was for them to help me with a few tasks, but today they simply are my entire IT staff. They are technically capable and are extremely fair as far as costs. I work with them 7 days a week and my business would not exist without them....they have helped me grow my business 300%.",
    },
    {
        imgSrc: randyBoldyga,
        name: "Randy Boldyga",
        role: "CEO/President",
        company: "RxNT",
        text: "Acube provided excellent service and demonstrated strong technical capability. I would highly recommend them for enterprise scaling.",
    },
    {
        imgSrc: guySimani,
        name: "Guy Simani",
        role: "President",
        company: "Emerald Capital Management",
        text: "The ACube team are reliable, responsive and diligent across all project pipelines.",
    },
    {
        imgSrc: chuckEast,
        name: "Chuck East",
        role: "Technical Product Manager",
        company: "Openn North America",
        text: "Thank you for everyone’s willingness to pull together around the shifting priorities coming into engineering. The hard work, extra hours, and deep product knowledge are examples of how the teams go the extra mile. I have been managing offshore teams for many years, and the Openn engineering team is by far the brightest and most dedicated.",
    },
    {
        imgSrc: JimTormey,
        name: "Jim Tormey",
        role: "Chief Executive Officer",
        company: "Sentry Road Training",
        text: "My name is Jim, and I run a learning management software business on Moodle. The Acube Technologies team has been phenomenal—responsive, communicative, and reliable. They followed through on every commitment and kept me informed of any challenges. I’m a big fan and look forward to working with them in the future.",
    },
];

const TestimonialCarousel = () => {
    // Refs for drag-to-scroll logic
    const scrollRef = useRef(null);
    const isDragging = useRef(false);
    const startX = useRef(0);
    const scrollLeft = useRef(0);

    // Mouse Event Handlers for Dragging
    const handleMouseDown = (e) => {
        isDragging.current = true;
        scrollRef.current.classList.add("active-drag");
        startX.current = e.pageX - scrollRef.current.offsetLeft;
        scrollLeft.current = scrollRef.current.scrollLeft;
    };

    const handleMouseLeave = () => {
        isDragging.current = false;
        if (scrollRef.current) scrollRef.current.classList.remove("active-drag");
    };

    const handleMouseUp = () => {
        isDragging.current = false;
        scrollRef.current.classList.remove("active-drag");
    };

    const handleMouseMove = (e) => {
        if (!isDragging.current) return;
        e.preventDefault();
        const x = e.pageX - scrollRef.current.offsetLeft;
        const walk = (x - startX.current) * 1.5; // Drag speed multiplier
        scrollRef.current.scrollLeft = scrollLeft.current - walk;
    };

    return (
        <>
            <style>{`
                /* --- Base Setup --- */
                .testimonial-showcase-section {
                    background-color: #f8fafc;
                    overflow: hidden;
                }
                .max-w-700 { max-width: 700px; }
                .tracking-wider { letter-spacing: 0.08em; }
                .bg-primary-subtle { background-color: rgba(13, 110, 253, 0.1); }

                /* --- The Magic Scroll Track --- */
                .scroll-track-container {
                    width: 100%;
                    padding-left: max(1rem, calc((100vw - 1320px) / 2)); 
                }

                .scroll-track {
                    display: flex;
                    gap: 1.5rem;
                    overflow-x: auto;
                    scroll-snap-type: x mandatory; 
                    padding-bottom: 3rem;
                    padding-right: 2rem;
                    cursor: grab; /* Enable grab cursor */
                    
                    /* Hide scrollbars */
                    scrollbar-width: none; 
                    -ms-overflow-style: none;  
                }

                .scroll-track::-webkit-scrollbar { display: none; }

                /* Dragging State Styles */
                .scroll-track.active-drag {
                    cursor: grabbing;
                    scroll-snap-type: none; /* Disable snapping while actively dragging */
                }
                
                .scroll-track.active-drag .modern-review-card {
                    user-select: none; /* Prevent text highlighting during drag */
                }

                /* --- The Modern Card --- */
                .modern-review-card {
                    flex: 0 0 320px; 
                    scroll-snap-align: start; 
                    display: flex;
                    flex-direction: column; 
                    border-radius: 1rem;
                    padding: 2rem;
                    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
                    border-color: #e2e8f0 !important;
                    transition: transform 0.3s ease, box-shadow 0.3s ease;
                }

                /* Do not apply hover lift if container is being dragged */
                .scroll-track:not(.active-drag) .modern-review-card:hover {
                    transform: translateY(-6px);
                    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
                }

                .review-text {
                    font-size: 1.05rem;
                    color: #334155 !important;
                }

                .lh-lg { line-height: 1.75 !important; }

                /* Breakpoint for Tablets/Desktops */
                @media (min-width: 768px) {
                    .modern-review-card { flex: 0 0 420px; }
                    .scroll-track-container { padding-left: max(1rem, calc((100vw - 960px) / 2)); }
                }
                @media (min-width: 1200px) {
                    .scroll-track-container { padding-left: max(1rem, calc((100vw - 1140px) / 2)); }
                }
                @media (min-width: 1400px) {
                    .scroll-track-container { padding-left: max(1rem, calc((100vw - 1320px) / 2)); }
                }
            `}</style>

            <section className="testimonial-showcase-section py-5 bg-light">
                <Container className="mb-5">
                    <div className="text-center max-w-700 mx-auto">
                        <span className="badge bg-primary-subtle text-primary rounded-pill px-3 py-2 mb-3 fw-semibold tracking-wider" style={{ fontSize: "1.25rem" }}>
                            CLIENT SUCCESS
                        </span>
                        <h2 className="display-5 ft-wt-700 text-dark mb-3">
                            Trusted by industry leaders.
                        </h2>
                        <p className="text-secondary ft-18">
                            See how we empower global engineering teams to innovate, scale, and deliver high-performance products reliably.
                        </p>
                    </div>
                </Container>

                {/* The Horizontal Scroll Track */}
                <div className="scroll-track-container">
                    <div
                        className="scroll-track"
                        ref={scrollRef}
                        onMouseDown={handleMouseDown}
                        onMouseLeave={handleMouseLeave}
                        onMouseUp={handleMouseUp}
                        onMouseMove={handleMouseMove}
                    >
                        {testimonials.map((item, index) => (
                            <div key={index} className="modern-review-card bg-white border">

                                {/* Quote Icon */}
                                <div className="quote-accent mb-4 text-primary">
                                    <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor" opacity="0.15">
                                        <path d="M13 14.725c0-5.141 3.892-10.519 10-11.725l.984 2.126c-2.215.835-4.161 2.94-4.808 5.768h3.824v8.831h-10v-5.0zm-13 0c0-5.141 3.892-10.519 10-11.725l.984 2.126c-2.215.835-4.161 2.94-4.808 5.768h3.824v8.831h-10v-5.0z" />
                                    </svg>
                                </div>

                                {/* Testimonial Text */}
                                <p className="review-text text-dark mb-4 lh-lg">
                                    "{item.text}"
                                </p>

                                {/* User Info - mt-auto forces this to the bottom perfectly */}
                                <div className="user-profile mt-auto d-flex align-items-center gap-3 pt-4 border-top">
                                    <img
                                        src={item.imgSrc}
                                        alt={item.name}
                                        loading="lazy"
                                        width="48"
                                        height="48"
                                        draggable="false" // CRUCIAL: Prevents ghost-dragging the image
                                        className="rounded-circle object-fit-cover border shadow-sm"
                                    />
                                    <div>
                                        <h4 className="ft-wt-700 ft-15 mb-0 text-dark">{item.name}</h4>
                                        <p className="text-muted ft-13 mb-0">
                                            {item.role}, <span className="text-primary fw-medium">{item.company}</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
};

export default TestimonialCarousel;